<template>
    <div class="atelier-exhibit-container">
        <div class="atelier-bottom">
            <div class="product-atelier-endingtitle">
                <CommonComponentsUnionTitleProductsEnding product-type="Atelier" />
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .atelier-exhibit-container {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        width: 100%;

        .atelier-bottom {
            position: relative;
            height: .convert(786px) [ @vw];
            .product-atelier-endingtitle {
                position: absolute;
                z-index: 0;
                width: 100%;
                padding: .convert(100px) [ @vw] 0;
            }
        }
    }
</style>
